export const ADD_ERROR = '[ERRORS] ADD_ERROR'
export const REMOVE_ERROR = '[ERRORS] REMOVE_ERROR'
